/* tslint:disable */
/* eslint-disable */

/**
 * 0 = PasswordReset
 * 1 = PasswordSet
 */
export enum TypeTokenValues {
  PasswordReset = 0,
  PasswordSet = 1
}
